<template>
  <div>
  <h3>{{ title }}</h3>
  <b-row class="card-body btn-shadow  rounded-lg mt-4 ">
    <b-col cols="2">
      <h-e-avatar
        :full-name="name"
        :size="96"
        :src="logo"
        :color="color"
        :icon="icon"
      />
    </b-col>
    <b-col cols="10">
      <b-row>
        <slot name="information"></slot>
        <b-col cols="2">
          <b-row class="d-flex justify-content-end ">
            <h-b-action
              :positive="false"
              icon="bx bx-edit-alt"
              :text="editName"
              @click.native="$emit('actionButton')"
            />
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default:'',
    },
    name: {
      type:String,
      default:'',
    },
    logo: {
      type:String,
      default:'',
    },
    icon: {
      type:String,
      default:'',
    },
    color: {
      type:String,
      default:'',
    },
    editName: {
      type:String,
      default:'Modifier',
    },
  },
  
  methods: {
    
  },
}
</script>

<style scoped>

</style>